import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import { useStyles, StyleSheet, padding, border, transition } from '@rexlabs/styling';
import { useWhereabouts, matchMany, Link } from '@rexlabs/whereabouts';
import { Tooltip } from '@rexlabs/tooltip';
import { Button } from '../button';
import { useNavigation } from '../../context';
import { WIDTHS } from '../../utils/constants';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread(_objectSpread({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    listStyle: 'none'
  }, transition.styles({
    target: 'navigation.item.container',
    property: 'opacity',
    duration: 'medium',
    easing: 'easeOut'
  })), padding.styles({
    target: 'navigation.item.container',
    all: 'xs'
  })), {}, {
    height: function height(_ref) {
      var token = _ref.token;
      return token('navigation.desktop.menu.width', WIDTHS.MENU.DESKTOP);
    },
    minHeight: function minHeight(_ref2) {
      var token = _ref2.token;
      return token('navigation.desktop.menu.width', WIDTHS.MENU.DESKTOP);
    },
    color: function color(_ref3) {
      var token = _ref3.token;
      return token('navigation.item.color', token('color.textStyle.body.contrast'));
    }
  }),
  item: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    color: 'inherit',
    cursor: 'pointer',
    opacity: 0.8,
    textDecoration: 'none'
  }, transition.styles.combine({
    target: 'navigation.item',
    presets: [{
      property: 'background-color',
      duration: 'medium',
      easing: 'easeOut'
    }, {
      property: 'opacity',
      duration: 'medium',
      easing: 'easeOut'
    }]
  })), padding.styles({
    target: 'navigation.item',
    all: function all() {
      return '1.4rem';
    }
  })), border.styles({
    target: 'navigation.item',
    all: {
      width: 'none',
      radius: 'l'
    }
  })), {}, {
    '&:hover, &:focus': {
      color: 'inherit',
      opacity: 1,
      background: function background(_ref4) {
        var token = _ref4.token;
        return token('navigation.item.hover.background.color', token('color.primary.hover.default'));
      }
    },
    '&::after': {
      position: 'absolute',
      content: "' '",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }),
  itemActive: {
    opacity: 1,
    background: function background(_ref5) {
      var token = _ref5.token;
      return token('navigation.item.active.background.color', token('color.primary.hover.default'));
    }
  },
  itemSelected: {
    opacity: 1,
    background: function background(_ref6) {
      var token = _ref6.token;
      return token('navigation.item.selected.background.color', token('color.primary.selected.default'));
    }
  }
});
export function MaybeLink(_ref7) {
  var children = _ref7.children,
      id = _ref7.id,
      to = _ref7.to,
      label = _ref7.label,
      attributes = _ref7.attributes,
      _ref7$subItems = _ref7.subItems,
      subItems = _ref7$subItems === void 0 ? [] : _ref7$subItems,
      _ref7$activeMatches = _ref7.activeMatches,
      activeMatches = _ref7$activeMatches === void 0 ? [] : _ref7$activeMatches;
  var s = useStyles(defaultStyles);
  var whereabouts = useWhereabouts();

  var _useNavigation = useNavigation(),
      activeItem = _useNavigation.activeItem,
      isExpanded = _useNavigation.isExpanded,
      isVisible = _useNavigation.isVisible,
      setActiveItem = _useNavigation.setActiveItem,
      setIsVisible = _useNavigation.setIsVisible;

  var isSelected = useMemo(function () {
    var allSubItems = _flatMapInstanceProperty(subItems).call(subItems, function (subItem) {
      if ('items' in subItem) {
        return subItem.items;
      }

      return subItem;
    }); // Take all sub items and their routes into account


    var subItemsRoutes = _reduceInstanceProperty(allSubItems).call(allSubItems, function (all, item, i) {
      if ('to' in item) {
        all["SUB".concat(i)] = item.to;
      }

      return all;
    }, {}); // + given active matches
    // + this items route


    var allRoutes = _reduceInstanceProperty(activeMatches).call(activeMatches, function (all, config, i) {
      all["ROUTE".concat(i)] = config;
      return all;
    }, _objectSpread(_objectSpread({}, subItemsRoutes), to ? {
      TO: to
    } : {})); // Then match against all these accumulated routes


    return matchMany(whereabouts, allRoutes);
  }, [to, whereabouts, subItems, activeMatches]);
  return /*#__PURE__*/React.createElement("li", s('container'), /*#__PURE__*/React.createElement(Tooltip, {
    placement: "right",
    distance: 8,
    isDisabled: activeItem || isExpanded || isVisible,
    Content: function Content() {
      return label;
    }
  }, to ? /*#__PURE__*/React.createElement(Link, _extends({}, attributes, s('item', {
    itemActive: activeItem === id,
    itemSelected: !!isSelected
  }), {
    to: to,
    onClick: function onClick() {
      setActiveItem(null);
      setIsVisible(false);
    }
  }), children) : /*#__PURE__*/React.createElement(Button, _extends({}, attributes, s('item', {
    itemActive: activeItem === id,
    itemSelected: !!isSelected
  }), {
    onClick: function onClick() {
      setActiveItem(function (prevActiveItem) {
        return prevActiveItem === id ? null : id;
      });
    }
  }), children)));
}